import React from 'react';

export const field = (label, value, isFullWidth = false) => (
  <div style={{ 
    marginBottom: 16,
    gridColumn: isFullWidth ? '1 / -1' : 'auto'
  }}>
    <div style={{ 
      fontFamily: 'Montserrat', 
      fontSize: '11px', 
      color: 'rgba(255, 255, 255, 0.5)',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      marginBottom: 6
    }}>
      {label}
    </div>
    <div style={{ 
      fontFamily: 'Montserrat', 
      fontSize: '15px', 
      color: '#FFFFFF',
      fontWeight: 500
    }}>
      {value || '—'}
    </div>
  </div>
);

export const sectionTitle = (icon, title) => (
  <div style={{ 
    display: 'flex', 
    alignItems: 'center', 
    gap: 10, 
    marginBottom: 20, 
    marginTop: 32,
    paddingBottom: 10,
    borderBottom: '1px solid rgba(86, 141, 237, 0.2)'
  }}>
    <i className={icon} style={{ color: '#568ded', fontSize: '16px' }}></i>
    <span style={{ 
      fontFamily: 'Montserrat', 
      fontSize: '16px', 
      fontWeight: 600, 
      color: '#FFFFFF',
      textTransform: 'uppercase',
      letterSpacing: '1px'
    }}>
      {title}
    </span>
  </div>
);

